module.exports = __webpack_public_path__ + "pc/img/about-global-person01.55f6d675.png";